module.exports = {
      id: "liveupdate-usage",
      viewBox: "0 0 14.54 20",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#liveupdate",
      toString: function () {
        return this.url;
      }
    }